/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEstimateByMonthDto } from './GetEstimateByMonthDto';
import {
    GetEstimateByMonthDtoFromJSON,
    GetEstimateByMonthDtoFromJSONTyped,
    GetEstimateByMonthDtoToJSON,
} from './GetEstimateByMonthDto';
import type { GetPositionDto } from './GetPositionDto';
import {
    GetPositionDtoFromJSON,
    GetPositionDtoFromJSONTyped,
    GetPositionDtoToJSON,
} from './GetPositionDto';
import type { GetProfileCategoryDto } from './GetProfileCategoryDto';
import {
    GetProfileCategoryDtoFromJSON,
    GetProfileCategoryDtoFromJSONTyped,
    GetProfileCategoryDtoToJSON,
} from './GetProfileCategoryDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetEstimateItemPurchaseDeficienciesDto
 */
export interface GetEstimateItemPurchaseDeficienciesDto {
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    id: string;
    /**
     * 
     * @type {GetEstimateByMonthDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    estimateByMonth: GetEstimateByMonthDto;
    /**
     * 
     * @type {Date}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    importFileName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesInvoicesSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseInvoicesSum: string;
    /**
     * 
     * @type {GetPositionDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    position: GetPositionDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    positionType: GetEstimateItemPurchaseDeficienciesDtoPositionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    rcSalesTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesSurchargePercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesDiscountPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesNet: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesCommissionPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesCommissionAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesNetTechnicalCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesBeerTax: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesPrintingCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesOperatingFee: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesBlockSurcharge: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesTransferCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    rcPurchase: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseTechnicalCost: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseBeerTax: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchasePrintingCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseOperatingFee: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseBlockSurcharge: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseTransferCosts: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseDiscountPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseNet: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseSurchargePercent: string;
    /**
     * 
     * @type {GetProfileCategoryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    profileCategory: GetProfileCategoryDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    isUpSell: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    netCustomerAccount: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    numberOfMedia: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    additionalDescription: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    orderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    ownName: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    technologyDictionary: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    regionDictionary: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    formatRadio: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    formatPress: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    formatInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    emissionTypeRadio: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    emissionTypeCinema: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseFormInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    categoryInternet: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    categoryLabcon: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    copySize: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    purchaseMethod: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    medium: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    labconChannel: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    ballDictionary: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    salesCommissionSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    service: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    actionGroup: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    serviceExternalWorkPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    serviceCreationPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    serviceChangeProductionPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    serviceStrategyPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    serviceProductionBroadcastPercent: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    serviceClientServicePercent: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    clone?: boolean;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    countryDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    pathPhaseDictionary?: GetDictionaryDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    specialistTeam?: GetTeamDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    deliveryTeam?: GetTeamDto;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    commentMediaplanner: string;
    /**
     * 
     * @type {string}
     * @memberof GetEstimateItemPurchaseDeficienciesDto
     */
    commentFinance: string;
}


/**
 * @export
 */
export const GetEstimateItemPurchaseDeficienciesDtoPositionTypeEnum = {
    Standard: 'Standard',
    Commission: 'Commission',
    TransferredCommission: 'TransferredCommission',
    TechnicalCost: 'TechnicalCost'
} as const;
export type GetEstimateItemPurchaseDeficienciesDtoPositionTypeEnum = typeof GetEstimateItemPurchaseDeficienciesDtoPositionTypeEnum[keyof typeof GetEstimateItemPurchaseDeficienciesDtoPositionTypeEnum];


/**
 * Check if a given object implements the GetEstimateItemPurchaseDeficienciesDto interface.
 */
export function instanceOfGetEstimateItemPurchaseDeficienciesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "estimateByMonth" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "importFileName" in value;
    isInstance = isInstance && "salesInvoicesSum" in value;
    isInstance = isInstance && "purchaseInvoicesSum" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "positionType" in value;
    isInstance = isInstance && "rcSalesTotal" in value;
    isInstance = isInstance && "salesSurchargePercent" in value;
    isInstance = isInstance && "salesDiscountPercent" in value;
    isInstance = isInstance && "salesNet" in value;
    isInstance = isInstance && "salesCommissionPercent" in value;
    isInstance = isInstance && "salesCommissionAmount" in value;
    isInstance = isInstance && "salesNetTechnicalCost" in value;
    isInstance = isInstance && "salesBeerTax" in value;
    isInstance = isInstance && "salesPrintingCosts" in value;
    isInstance = isInstance && "salesOperatingFee" in value;
    isInstance = isInstance && "salesBlockSurcharge" in value;
    isInstance = isInstance && "salesTransferCosts" in value;
    isInstance = isInstance && "salesNetTotal" in value;
    isInstance = isInstance && "rcPurchase" in value;
    isInstance = isInstance && "purchaseTechnicalCost" in value;
    isInstance = isInstance && "purchaseBeerTax" in value;
    isInstance = isInstance && "purchasePrintingCosts" in value;
    isInstance = isInstance && "purchaseOperatingFee" in value;
    isInstance = isInstance && "purchaseBlockSurcharge" in value;
    isInstance = isInstance && "purchaseTransferCosts" in value;
    isInstance = isInstance && "purchaseDiscountPercent" in value;
    isInstance = isInstance && "purchaseNetTotal" in value;
    isInstance = isInstance && "purchaseNet" in value;
    isInstance = isInstance && "purchaseSurchargePercent" in value;
    isInstance = isInstance && "profileCategory" in value;
    isInstance = isInstance && "isUpSell" in value;
    isInstance = isInstance && "netCustomerAccount" in value;
    isInstance = isInstance && "numberOfMedia" in value;
    isInstance = isInstance && "additionalDescription" in value;
    isInstance = isInstance && "orderNumber" in value;
    isInstance = isInstance && "ownName" in value;
    isInstance = isInstance && "technologyDictionary" in value;
    isInstance = isInstance && "regionDictionary" in value;
    isInstance = isInstance && "formatRadio" in value;
    isInstance = isInstance && "formatPress" in value;
    isInstance = isInstance && "formatInternet" in value;
    isInstance = isInstance && "emissionTypeRadio" in value;
    isInstance = isInstance && "emissionTypeCinema" in value;
    isInstance = isInstance && "purchaseFormInternet" in value;
    isInstance = isInstance && "categoryInternet" in value;
    isInstance = isInstance && "categoryLabcon" in value;
    isInstance = isInstance && "copySize" in value;
    isInstance = isInstance && "purchaseMethod" in value;
    isInstance = isInstance && "medium" in value;
    isInstance = isInstance && "labconChannel" in value;
    isInstance = isInstance && "ballDictionary" in value;
    isInstance = isInstance && "salesCommissionSum" in value;
    isInstance = isInstance && "service" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "actionGroup" in value;
    isInstance = isInstance && "serviceExternalWorkPercent" in value;
    isInstance = isInstance && "serviceCreationPercent" in value;
    isInstance = isInstance && "serviceChangeProductionPercent" in value;
    isInstance = isInstance && "serviceStrategyPercent" in value;
    isInstance = isInstance && "serviceProductionBroadcastPercent" in value;
    isInstance = isInstance && "serviceClientServicePercent" in value;
    isInstance = isInstance && "commentMediaplanner" in value;
    isInstance = isInstance && "commentFinance" in value;

    return isInstance;
}

export function GetEstimateItemPurchaseDeficienciesDtoFromJSON(json: any): GetEstimateItemPurchaseDeficienciesDto {
    return GetEstimateItemPurchaseDeficienciesDtoFromJSONTyped(json, false);
}

export function GetEstimateItemPurchaseDeficienciesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEstimateItemPurchaseDeficienciesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'estimateByMonth': GetEstimateByMonthDtoFromJSON(json['estimateByMonth']),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'comment': json['comment'],
        'importFileName': json['importFileName'],
        'salesInvoicesSum': json['salesInvoicesSum'],
        'purchaseInvoicesSum': json['purchaseInvoicesSum'],
        'position': GetPositionDtoFromJSON(json['position']),
        'positionType': json['positionType'],
        'rcSalesTotal': json['rcSalesTotal'],
        'salesSurchargePercent': json['salesSurchargePercent'],
        'salesDiscountPercent': json['salesDiscountPercent'],
        'salesNet': json['salesNet'],
        'salesCommissionPercent': json['salesCommissionPercent'],
        'salesCommissionAmount': json['salesCommissionAmount'],
        'salesNetTechnicalCost': json['salesNetTechnicalCost'],
        'salesBeerTax': json['salesBeerTax'],
        'salesPrintingCosts': json['salesPrintingCosts'],
        'salesOperatingFee': json['salesOperatingFee'],
        'salesBlockSurcharge': json['salesBlockSurcharge'],
        'salesTransferCosts': json['salesTransferCosts'],
        'salesNetTotal': json['salesNetTotal'],
        'rcPurchase': json['rcPurchase'],
        'purchaseTechnicalCost': json['purchaseTechnicalCost'],
        'purchaseBeerTax': json['purchaseBeerTax'],
        'purchasePrintingCosts': json['purchasePrintingCosts'],
        'purchaseOperatingFee': json['purchaseOperatingFee'],
        'purchaseBlockSurcharge': json['purchaseBlockSurcharge'],
        'purchaseTransferCosts': json['purchaseTransferCosts'],
        'purchaseDiscountPercent': json['purchaseDiscountPercent'],
        'purchaseNetTotal': json['purchaseNetTotal'],
        'purchaseNet': json['purchaseNet'],
        'purchaseSurchargePercent': json['purchaseSurchargePercent'],
        'profileCategory': GetProfileCategoryDtoFromJSON(json['profileCategory']),
        'isUpSell': json['isUpSell'],
        'netCustomerAccount': json['netCustomerAccount'],
        'numberOfMedia': json['numberOfMedia'],
        'additionalDescription': json['additionalDescription'],
        'orderNumber': json['orderNumber'],
        'ownName': json['ownName'],
        'technologyDictionary': GetDictionaryDtoFromJSON(json['technologyDictionary']),
        'regionDictionary': GetDictionaryDtoFromJSON(json['regionDictionary']),
        'formatRadio': GetDictionaryDtoFromJSON(json['formatRadio']),
        'formatPress': GetDictionaryDtoFromJSON(json['formatPress']),
        'formatInternet': GetDictionaryDtoFromJSON(json['formatInternet']),
        'emissionTypeRadio': GetDictionaryDtoFromJSON(json['emissionTypeRadio']),
        'emissionTypeCinema': GetDictionaryDtoFromJSON(json['emissionTypeCinema']),
        'purchaseFormInternet': GetDictionaryDtoFromJSON(json['purchaseFormInternet']),
        'categoryInternet': GetDictionaryDtoFromJSON(json['categoryInternet']),
        'categoryLabcon': GetDictionaryDtoFromJSON(json['categoryLabcon']),
        'copySize': GetDictionaryDtoFromJSON(json['copySize']),
        'purchaseMethod': GetDictionaryDtoFromJSON(json['purchaseMethod']),
        'medium': GetDictionaryDtoFromJSON(json['medium']),
        'labconChannel': GetDictionaryDtoFromJSON(json['labconChannel']),
        'ballDictionary': GetDictionaryDtoFromJSON(json['ballDictionary']),
        'salesCommissionSum': json['salesCommissionSum'],
        'service': json['service'],
        'action': json['action'],
        'actionGroup': json['actionGroup'],
        'serviceExternalWorkPercent': json['serviceExternalWorkPercent'],
        'serviceCreationPercent': json['serviceCreationPercent'],
        'serviceChangeProductionPercent': json['serviceChangeProductionPercent'],
        'serviceStrategyPercent': json['serviceStrategyPercent'],
        'serviceProductionBroadcastPercent': json['serviceProductionBroadcastPercent'],
        'serviceClientServicePercent': json['serviceClientServicePercent'],
        'clone': !exists(json, 'clone') ? undefined : json['clone'],
        'countryDictionary': !exists(json, 'countryDictionary') ? undefined : GetDictionaryDtoFromJSON(json['countryDictionary']),
        'pathPhaseDictionary': !exists(json, 'pathPhaseDictionary') ? undefined : GetDictionaryDtoFromJSON(json['pathPhaseDictionary']),
        'specialistTeam': !exists(json, 'specialistTeam') ? undefined : GetTeamDtoFromJSON(json['specialistTeam']),
        'deliveryTeam': !exists(json, 'deliveryTeam') ? undefined : GetTeamDtoFromJSON(json['deliveryTeam']),
        'commentMediaplanner': json['commentMediaplanner'],
        'commentFinance': json['commentFinance'],
    };
}

export function GetEstimateItemPurchaseDeficienciesDtoToJSON(value?: GetEstimateItemPurchaseDeficienciesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'estimateByMonth': GetEstimateByMonthDtoToJSON(value.estimateByMonth),
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'comment': value.comment,
        'importFileName': value.importFileName,
        'salesInvoicesSum': value.salesInvoicesSum,
        'purchaseInvoicesSum': value.purchaseInvoicesSum,
        'position': GetPositionDtoToJSON(value.position),
        'positionType': value.positionType,
        'rcSalesTotal': value.rcSalesTotal,
        'salesSurchargePercent': value.salesSurchargePercent,
        'salesDiscountPercent': value.salesDiscountPercent,
        'salesNet': value.salesNet,
        'salesCommissionPercent': value.salesCommissionPercent,
        'salesCommissionAmount': value.salesCommissionAmount,
        'salesNetTechnicalCost': value.salesNetTechnicalCost,
        'salesBeerTax': value.salesBeerTax,
        'salesPrintingCosts': value.salesPrintingCosts,
        'salesOperatingFee': value.salesOperatingFee,
        'salesBlockSurcharge': value.salesBlockSurcharge,
        'salesTransferCosts': value.salesTransferCosts,
        'salesNetTotal': value.salesNetTotal,
        'rcPurchase': value.rcPurchase,
        'purchaseTechnicalCost': value.purchaseTechnicalCost,
        'purchaseBeerTax': value.purchaseBeerTax,
        'purchasePrintingCosts': value.purchasePrintingCosts,
        'purchaseOperatingFee': value.purchaseOperatingFee,
        'purchaseBlockSurcharge': value.purchaseBlockSurcharge,
        'purchaseTransferCosts': value.purchaseTransferCosts,
        'purchaseDiscountPercent': value.purchaseDiscountPercent,
        'purchaseNetTotal': value.purchaseNetTotal,
        'purchaseNet': value.purchaseNet,
        'purchaseSurchargePercent': value.purchaseSurchargePercent,
        'profileCategory': GetProfileCategoryDtoToJSON(value.profileCategory),
        'isUpSell': value.isUpSell,
        'netCustomerAccount': value.netCustomerAccount,
        'numberOfMedia': value.numberOfMedia,
        'additionalDescription': value.additionalDescription,
        'orderNumber': value.orderNumber,
        'ownName': value.ownName,
        'technologyDictionary': GetDictionaryDtoToJSON(value.technologyDictionary),
        'regionDictionary': GetDictionaryDtoToJSON(value.regionDictionary),
        'formatRadio': GetDictionaryDtoToJSON(value.formatRadio),
        'formatPress': GetDictionaryDtoToJSON(value.formatPress),
        'formatInternet': GetDictionaryDtoToJSON(value.formatInternet),
        'emissionTypeRadio': GetDictionaryDtoToJSON(value.emissionTypeRadio),
        'emissionTypeCinema': GetDictionaryDtoToJSON(value.emissionTypeCinema),
        'purchaseFormInternet': GetDictionaryDtoToJSON(value.purchaseFormInternet),
        'categoryInternet': GetDictionaryDtoToJSON(value.categoryInternet),
        'categoryLabcon': GetDictionaryDtoToJSON(value.categoryLabcon),
        'copySize': GetDictionaryDtoToJSON(value.copySize),
        'purchaseMethod': GetDictionaryDtoToJSON(value.purchaseMethod),
        'medium': GetDictionaryDtoToJSON(value.medium),
        'labconChannel': GetDictionaryDtoToJSON(value.labconChannel),
        'ballDictionary': GetDictionaryDtoToJSON(value.ballDictionary),
        'salesCommissionSum': value.salesCommissionSum,
        'service': value.service,
        'action': value.action,
        'actionGroup': value.actionGroup,
        'serviceExternalWorkPercent': value.serviceExternalWorkPercent,
        'serviceCreationPercent': value.serviceCreationPercent,
        'serviceChangeProductionPercent': value.serviceChangeProductionPercent,
        'serviceStrategyPercent': value.serviceStrategyPercent,
        'serviceProductionBroadcastPercent': value.serviceProductionBroadcastPercent,
        'serviceClientServicePercent': value.serviceClientServicePercent,
        'clone': value.clone,
        'countryDictionary': GetDictionaryDtoToJSON(value.countryDictionary),
        'pathPhaseDictionary': GetDictionaryDtoToJSON(value.pathPhaseDictionary),
        'specialistTeam': GetTeamDtoToJSON(value.specialistTeam),
        'deliveryTeam': GetTeamDtoToJSON(value.deliveryTeam),
        'commentMediaplanner': value.commentMediaplanner,
        'commentFinance': value.commentFinance,
    };
}

